 
import { createSlice } from '@reduxjs/toolkit';

// Initial state now includes an array  
const initialState = {
  searchedProduct: [], // Array to hold the list of searchedProductSlice
 };

/**
 * Product Slice.
 */
export const searchedProductSlice = createSlice({
  name: 'searchedProduct',
  initialState,
  reducers: {
       
    // Action to set a list of searchedProductSlice
    setsearchedProductSlice: (state, action) => {
      state.searchedProduct = action.payload;
    },
    setsearchedProductSliceStore: (state, action) => {
      state.searchedProduct = action.payload;
    },
    
    // Action to reset the list of searchedProductSlice
    resetsearchedProductSlice: (state) => {
      state.searchedProduct = [];
    },

    // Action to add a new product to the list
    addProduct: (state, action) => {
      const newProduct = action.payload;
      const exists = state.searchedProduct.some((product) => product.id === newProduct.id);
    
      if (!exists) {
        state.searchedProduct.push(newProduct);
      }
    },
    
    // Action to update an existing product in the list
    updateProduct: (state, action) => {
      const updatedProduct = action.payload;
      const index = state.searchedProduct.findIndex((product) => product.id === updatedProduct.id);

      if (index !== -1) {
        state.searchedProduct[index] = updatedProduct;
      }
    },
  
    
  },
});

// Exporting the actions for use
export const { 
  setProduct, 
  setsearchedProductSlice, 
  setsearchedProductSliceStore,
  resetProduct, 
  resetsearchedProductSlice, 
  addProduct, 
  updateProduct

} = searchedProductSlice.actions;

// Exporting the reducer to be used in the store
export default searchedProductSlice.reducer;
